var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { getGeometryStyle } from '../../helpers/styles';
var VerticalLine = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1px;\n  height: 100%;\n  background-color: white;\n"], ["\n  width: 1px;\n  height: 100%;\n  background-color: white;\n"])));
var StyledDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-color: ", ";\n  ", "\n  ", "\n"], ["\n  border-color: ", ";\n  ", "\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.line.borderColor;
}, function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var attributes = _a.attributes;
    return "\n      " + (attributes && attributes.display
        ? "display:  " + attributes.display + "; "
        : '') + "\n      " + (attributes && attributes.justifyContent
        ? "justify-content: " + attributes.justifyContent + ";"
        : '') + "\n  ";
});
var Line = function (props) {
    var orientation = props.attributes.orientation;
    return (React.createElement(StyledDiv, __assign({}, props), orientation.toLowerCase() === 'vertical' ? (React.createElement(VerticalLine, null)) : (React.createElement("hr", { style: { borderColor: props.windowTheme.line.borderColor } }))));
};
export default Line;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map